import React from "react";
import { motion } from "framer-motion";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import "./ContactUs.scss";

const ContactUs = () => {
  return (
    <div className="contact-wrapper">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-overlay"></div>
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="sub-tag">Get In Touch</span>
          <h1>Let’s Start a <span>Conversation</span></h1>
          <p>
            Whether you have a question, project idea, or need support — our team
            is ready to help you build the future.
          </p>
        </motion.div>
      </section>

      {/* Info Cards Section */}
      <section className="contact-cards-container">
        <div className="cards-grid">
          {[
            {
              icon: <FaEnvelope />,
              title: "Email Us",
              value: "support@econsignsoft.com",
              link: "mailto:support@econsignsoft.com",
              desc: "Online support 24/7"
            },
            {
              icon: <FaPhoneAlt />,
              title: "Call Us",
              value: "+91 20-67622438",
              link: "tel:+912067622438",
              desc: "Mon - Fri, 9:30 to 6:30"
            },
            {
              icon: <FaMapMarkerAlt />,
              title: "Our Office",
              value: "Kondhwa, Pune, India",
              link: "#",
              desc: "Visit our HQ"
            },
          ].map((item, index) => (
            <motion.div
              className="info-card"
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="icon-box">{item.icon}</div>
              <h3>{item.title}</h3>
              <p className="card-desc">{item.desc}</p>
              <a href={item.link}>{item.value}</a>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Form Section */}
      <section className="contact-main-section">
        <div className="container">
          <div className="form-grid">
            <motion.div 
              className="form-visual"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className="visual-content">
                <h2>Why Choose EconSign?</h2>
                <ul className="benefits-list">
                  <li><span>✓</span> Expert Technical Consulting</li>
                  <li><span>✓</span> Scalable Software Solutions</li>
                  <li><span>✓</span> Dedicated Project Support</li>
                </ul>
              </div>
            </motion.div>

            <motion.div 
              className="form-container-box"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className="form-header">
                <h3>Send Us A Message</h3>
                <p>We'll get back to you within 24 business hours.</p>
              </div>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="input-row">
                  <div className="input-group">
                    <label>Full Name</label>
                    <input type="text" placeholder="Your Name" required />
                  </div>
                  <div className="input-group">
                    <label>Email Address</label>
                    <input type="email" placeholder="Email Address" required />
                  </div>
                </div>
                <div className="input-row">
                  <div className="input-group">
                    <label>Phone Number</label>
                    <input type="tel" placeholder="Phone Number" />
                  </div>
                  <div className="input-group">
                    <label>Website (Optional)</label>
                    <input type="text" placeholder="Your Website" />
                  </div>
                </div>
                <div className="input-group">
                  <label>Your Message</label>
                  <textarea placeholder="How can we help you?" required></textarea>
                </div>
                <button type="submit" className="submit-btn">
                  Submit Message <FaPaperPlane />
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <div className="map-title-wraper"> 
        <span className="map-title">Locate us on google maps</span> 
      </div>
        
      <section className="map-section">
        <div className="map-wrapper">
          <iframe
            title="econsign-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.792675112706!2d73.89681627371834!3d18.44772017139843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2ebd31be5f9c7%3A0xb407ae10706907e7!2sEconsign%20Soft%20Private%20Limited!5e0!3m2!1sen!2sin!4v1766409227695!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;